export const scrollToTop = () => {
    document.querySelectorAll('*').forEach( (element: any) => {
        element.scroll({ top: 0, behaviour: 'smooth'})
     })
}